// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__nBemX","containerItemsCenter":"Skeleton_containerItemsCenter__99nw8"};